export function normalizeHubQuery(value) {
  return String(value || '')
    .toLowerCase()
    .trim();
}

export function matchesHubQuery(item, rawQuery) {
  const query = normalizeHubQuery(rawQuery);
  if (!query) return true;

  const tokens = query.split(/\s+/).filter(Boolean);
  const haystack = String(item.title || '').toLowerCase();

  if (haystack.includes(query)) return true;
  return tokens.every((token) => haystack.includes(token));
}

export function filterHubItems(items, rawQuery) {
  const query = normalizeHubQuery(rawQuery);
  if (!query) return items;
  return items.filter((item) => matchesHubQuery(item, query));
}
